var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficInfoSelenaEce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_info_x5F_selena_x5F_ece",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "54px",
    viewBox: "0 0 70 54",
    style: {
      enableBackground: "new 0 0 70 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_info_x5F_selena_x5F_ece_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 22,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 18,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 24,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 20,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 24,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 20,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 22,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 18,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 24,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 20,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "street"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M24,50v-2c21.417,0,36.266-1.883,38.751-4.914c0.318-0.389,0.311-0.68,0.269-0.89 c-0.45-2.249-4.747-3.155-8.199-3.883c-3.299-0.695-5.903-1.244-6.715-2.866c-0.451-0.903-0.396-1.896,0.159-2.792 C49.231,31.092,51.59,30,54,30v2c-1.865,0-3.516,0.868-4.034,1.707c-0.242,0.392-0.165,0.658-0.071,0.846 c0.379,0.759,3.245,1.362,5.338,1.804c4.237,0.894,9.04,1.905,9.748,5.447c0.181,0.903-0.056,1.784-0.683,2.55 C60.27,49.267,37.321,50,24,50z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "triangle_x5F_white",
    style: {
      fill: "#FFFFFF"
    },
    d: "M45.158,38.512L26.604,6.042C26.063,5.096,25.09,4.531,24,4.531 c-1.09,0-2.064,0.565-2.604,1.511L2.842,38.512c-0.537,0.938-0.533,2.058,0.009,2.993C3.394,42.441,4.364,43,5.446,43h37.107 c1.081,0,2.052-0.559,2.595-1.494S45.695,39.451,45.158,38.512z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "triangle_x5F_red",
    style: {
      fill: "#B33229"
    },
    d: "M24,9.547L40.83,39H7.17L24,9.547 M24,5.531 c-0.676,0-1.353,0.336-1.736,1.008L3.71,39.008C2.948,40.341,3.911,42,5.446,42h37.107c1.536,0,2.498-1.659,1.736-2.992 L25.736,6.539C25.353,5.867,24.676,5.531,24,5.531L24,5.531z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_front_1_",
    d: "M32.333,30l-0.74-1.109C31.223,28.334,30.598,28,29.93,28H26.07c-0.669,0-1.293,0.334-1.664,0.891 L23.667,30H23v1v2v1v2h2v-2h6v2h2v-2v-1v-2v-1H32.333z M25.238,29.445C25.424,29.166,25.735,29,26.07,29h3.859 c0.335,0,0.646,0.166,0.832,0.445L31.798,31h-7.596L25.238,29.445z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_back_1_",
    d: "M26.07,26H28v-2v-1h-0.667l-0.74-1.109C26.223,21.334,25.598,21,24.93,21H21.07 c-0.669,0-1.293,0.334-1.664,0.891L18.667,23H18v1v2v1v2h2v-2h3.428C24.149,26.364,25.083,26,26.07,26z M19.202,24l1.036-1.555 C20.424,22.166,20.735,22,21.07,22h3.859c0.335,0,0.646,0.166,0.832,0.445L26.798,24H19.202z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficInfoSelenaEce);
export default __webpack_public_path__ + "static/media/icon-traffic_info_selena_ece.f99c9a817021dbd60c645f5ad1900869.svg";
export { ForwardRef as ReactComponent };